import {oldListRedirect} from '~/utils/competitionsPage';
import {oldSubPageRedirect} from '~/utils/competitionAdmin';

// X144: the five per-format admin LIST pages (/admin/clubs/{id}/leagues, /ladders, /tournaments, /americanos, /meets)
// are one Competitions page now. An old address redirects there with that format picked (a 301 on the server, so
// bookmarks and old emails land right). The create markers (?wizard=1, ?action=create) carry over as ?create=<format>
// so the wizard still opens.
// X162: a competition's old sub-pages (/leagues/{id}/settings, /ladders/{id}/players, /tournaments/{id}/teams,
// …/payments) are tabs of the competition's one page now (?tab=, the way every other tabbed admin page works), so
// those addresses 301 to the page with the tab, every other query key kept. A meet date's page is its own page and
// is not touched.
export default defineNuxtRouteMiddleware((to) => {
  const target = oldListRedirect(to.path, to.query) ?? oldSubPageRedirect(to.path, to.query);
  if (target) return navigateTo(target, {redirectCode: 301});
});
